import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { DiscountListParams } from '../api/discounts-api';
import { DISCOUNT_FILTER_FIELDS, DISCOUNT_SORTS } from '../components/discount-filters';

/** URL search params of the discounts list; mirrors GET /admin/v1/stores/{storeId}/discounts. */
export const discountListSearchSchema = indexSearchSchema(DISCOUNT_FILTER_FIELDS, {
  sort: DISCOUNT_SORTS,
});

export type DiscountListSearch = z.infer<typeof discountListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function discountListParams(search: DiscountListSearch): DiscountListParams {
  return listParams(search, DISCOUNT_FILTER_FIELDS);
}
